import css from 'styled-jsx/css'

import { colors, sizes, common } from '../../theme'


export default css`
main {
  ${common.page}
}

.portfolio {
  max-width: ${sizes.body.tablet.maxWidth};
  margin: 4rem auto;
  padding: 0 2rem;
}

.portfolio :global(h1) {
  margin-bottom: 6rem;
  margin-top: 4rem;
}

section.portfolio :global(.link-projects) {
  display: block;
  width: 100%;
  margin-top: 6rem;
  margin-bottom: 3rem;
  color: ${colors.pureWhite};
}

section.portfolio :global(.link-projects span) {
  ${common.h2}
  color: ${colors.pureWhite};
  font-weight: 400;
}


section.portfolio :global(ol) {
  width: 100%;
  margin-bottom: 4rem;
}

section.portfolio :global(ol .label) {
  font-size: 1.4rem;
}

section.portfolio :global(hr) {
  display: none;
}

#technologies {
  position: relative;
  top: -${sizes.header.desktop.height};
}

.technologies :global(.baseline) {
  color: ${colors.pureWhite};
  width: 100%;
}

.technologies {
  padding-top: 5rem;
  background: ${colors.midnightExpress};
  position: relative;
  max-width: ${sizes.body.tablet.maxWidth};
  margin: 5rem auto;
}

.technologies :global(h1) {
  margin-top: 4rem;
}

.technologies .title-link {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: ${sizes.body.tablet.maxWidth};
}

@media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
  main {
    min-width: ${sizes.constants.tablet.minWidth};
  }



  section.portfolio :global(.link-projects) {
    margin-top: 3rem;
  }

  section.portfolio :global(.link-projects span) {
    ${common.h4}
  }


  .portfolio {
    margin-bottom: 0;
  }

  #technologies {
    top: -${sizes.header.mobile.height};
  }
}
`
